/**
 * "now" is captured in a closure so callers don't need to pass a reference
 * date. Used by AppDetail subcomponents for "X ago" rendering.
 */
export function formatRelative(iso: string | undefined | null, now = Date.now()): string {
  if (!iso) return "—";
  const ts = Date.parse(iso);
  if (Number.isNaN(ts)) return iso;
  const diff = now - ts;
  if (diff < 0) return "только что";
  if (diff < 5_000) return "только что";
  if (diff < 60_000) return `${Math.floor(diff / 1_000)} с назад`;
  if (diff < 3_600_000) return `${Math.floor(diff / 60_000)} мин назад`;
  if (diff < 86_400_000) return `${Math.floor(diff / 3_600_000)} ч назад`;
  if (diff < 2_592_000_000) return `${Math.floor(diff / 86_400_000)} дн назад`;
  return new Date(ts).toLocaleDateString();
}
